import React, { useMemo, useState , useNavigate } from "react";
import axios from "axios";
import Costanti from '../../constantiX';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText,Dialog,FileUpload,Toast, RadioButton  } from "primereact";
import QRCode from "react-qr-code";
import { Servizi } from "../../services/Servizi";
import ReactGA from 'react-ga4';
import "../../assets/css/badge.css";

class ListaFornitori extends React.Component {

    constructor() {
        super();
        this.actions =[
            {
                id:1,
                icon: "pi-search",
                label: "",
                action: (e) => {this.vai(e,'V');console.log("View")},
            },
            {
                id:2,
                icon: "pi-pencil",
                label: "",
                action: (e) => {this.vai(e,'U');console.log("Edit")},
            },
            {
                id:3,
                icon: "pi-trash",
                label: "",
                action: (e) => {this.vai(e,'D');console.log("Delete")},
            },
     
        ];
        this.token=sessionStorage.getItem("ICEtoken");
        this.utente=JSON.parse(sessionStorage.getItem("utente"));
        this.state = { xcarica:'sezione', fornitori:[], totalRecords:0, pageSize:10, first:0, visible2: false,visible3: false };
        this.onPage = this.onPage.bind(this);
    }
    caricaDati(pagina,numrec){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         var quer='page='+pagina+'&num='+numrec+'&aziendaid='+this.utente.aziendaid;
        axios.get(Costanti.UrlCallApi+"fornitore/all?"+quer,config)
        .then(res => {
            res.data.lista1.forEach(element => {
                element.azioni=this.actions
            });
            this.setState({fornitori:res.data.lista1,totalRecords:res.data.conta1,loading:false})
            
            //alert(JSON.stringify(this.state.prodotti))
           }).catch(error=> {
             alert(error)
        });
    } 

    componentDidMount() {
        //alert(this.props.location.pathname);
  ReactGA.send({ hitType: "pageview", page:this.props.location.pathname});
       this.caricaDati(1,this.state.pageSize);  
    }
    
          
    showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }

    onPage(event) {
        this.setState({
            loading: true,
            activePage:(event.page+1),
            first:event.first
       });
       this.caricaDati((event.page+1),this.state.pageSize)
    }
   
    vai(id,tipo){
        this.props.history.push('/fornitore/'+id+'/'+tipo)
    }
    setImporta(value){
        this.setState({importaXLS:value});
    }
    setPDF(value){
        let config = {
             headers: {
               'Authorization': 'Bearer ' + this.token
             }
           }
         axios.get(Costanti.UrlCallApi+"stampe/fornitori/"+this.utente.aziendaid,config)
         .then((res) => {
    
     const link = document.createElement('a');
     const url=Costanti.UrlCallApi+"file/getFile/"+res.data;
     
     link.href = url;
     link.setAttribute(
       'download',
       res.data
     );
     // Append to html link element page
     document.body.appendChild(link);
     // Start download
     link.click();
     // Clean up and remove the link
     link.parentNode.removeChild(link);
      }).catch(error=> {
             this.showMessage('error','Errore nella stampa',error.message);
         this.setState({isSubmitting:false});
     });
 
     }
    
    caricato(){
        this.showMessage('info','Caricamento','File Excel elaborato');
    }
    
    render() {
    return (
        <div>
               <Toast ref={(el) => this.toastBC = el} position="bottom-center" />

               <Dialog header="Importa" 
       closable={false} visible={this.state.importaXLS} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
         <div className="cardc1 mx-3 mb-3  p-3 border-1 border-50 border-round h-full md:h-full lg:h-full">
            <RadioButton value="sezione" name="xc" onChange={(e) => this.setState({xcarica:e.value})} checked={this.state.xcarica === 'sezione'}/> <span>Verranno caricati i dati del foglio Excel corrispondete a questa sezione</span>
            </div>
            <div className="cardc1 mx-3 mb-3  p-3 border-1 border-50 border-round h-full md:h-full lg:h-full">
            <RadioButton value="tutti" name="xc" onChange={(e) => this.setState({xcarica:e.value})} checked={this.state.xcarica === 'tutti'} /> Verranno caricati i dati di tutti i fogli dell'Excel
         </div>
           <FileUpload id="filexls" mode="basic" name="avatar"
                          url={Costanti.UrlCallApi+'file/caricaxlsx/fornitori/'+this.state.xcarica+'/'+this.utente.aziendaid} 
                          onError={()=> this.showMessage('error','Errore','Si è verificato un errore nel caricamento')}
                          onUpload={()=>this.caricato()}
                         accept=".xlsx" maxFileSize={10000000} chooseOptions={{ className: 'p-button-plain p-button-outlined' }} chooseLabel="Carica File Excel" />
          
                <footer>
        <div className="border-top-1 surface-border pt-3">
                <Button type="button" icon="pi pi-check" onClick={() => this.setImporta(false)} label="Chiudi" />
        </div>
            </footer>
       </Dialog>
       <Dialog header="PDF" 
       closable={false} visible={this.state.viewPDF} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
        
                        <footer>
        <div className="border-top-1 surface-border pt-3">
                <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
        </div>
  

            </footer>
       </Dialog>

       <Dialog header="PDF" 
       closable={false} visible={this.state.viewPDF} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
        
                        <footer>
        <div className="border-top-1 surface-border pt-3">
                <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
        </div>
  

            </footer>
       </Dialog>
       <DataTable value={this.state.fornitori} 
        rows={this.state.pageSize} totalRecords={this.state.totalRecords}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
        paginator={true} onPage={this.onPage}
        responsive={true} loading={this.state.loading}
        lazy={true} first={this.state.first}
               header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Fornitori</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              <Button label="Importa da Excel" onClick={()=>this.setImporta(true)} icon="pi pi-file-excel" className="p-button-rounded  p-button-success"/>
              <Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/>
                            <Button label="Aggiungi"  onClick={()=>this.vai(0,'A')}  icon="pi pi-plus" className="p-button-rounded p-button-primary "/>
               </div>
              }  
              responsiveLayout="stack">
            <Column field="name" body={(item) => <img width="45px" src={Costanti.UrlCallApi+'file/get/fornitore/'+item.id}  alt=""/>} />
            <Column field="ragionesociale" header="Ragione Sociale" />
            <Column  header="Email" body={(item) => <a href={`mailto:${item.email}`}>{item.email}</a>} />
            <Column field="telefono" header="Telefono" />
            <Column field="sede" header="Sede" />
            <Column field="status" header="Stato" body={(item) => <span className={`customer-badge status-${item.status}`}>{item.status}</span>} />
          
            <Column id="id5"
                field="id"
                header="Azioni"
                body={(item) => (
                    <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                        {this.actions.map((action) => (
                            <Button
                                key={action.id}
                                className="p-button-sm"
                                icon={`pi ${action.icon}`}
                                label={action.label}
                                aria-label={action.label}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.action(item.id);
                                }}
                            />
                        ))}
                    </div>
                )}
            ></Column>
        </DataTable>
        </div>
     
    );
   }
};
export default ListaFornitori;
